<template>
  <div class="checkout_redesign--single-step-wrapper">
    <div class="checkout_redesign--single-step_header-wrapper">
      <h2 class="checkout_redesign--single-step_header">
        {{ stepTitle }}
      </h2>
    </div>
    <div class="checkout_redesign--step">
      <div class="checkout_redesign--red-section"></div>
      <template>
        <slot></slot>
      </template>
      <div
        class="checkout_redesign--blue-section checkout_redesign--section--bottom"
      >
        <a @click="proceedToNextStep">
          <button
            type="submit"
            class="checkout_redesign--text-uppercase"
            :disabled="disableButton"
          >
            {{ buttonText }}
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepTitle: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    disableButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    proceedToNextStep() {
      this.$emit("nextStep");
    },
  },
};
</script>
